'use client'

import { MdMenu } from 'react-icons/md'

import NotificationBell from '../private/notification-bell'

import HelpCenter from './help-center'

import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import { useAppSelector } from '@/libs/hooks/use-app-selector'
import { toggleSidebar } from '@/libs/store/slice/ui-slice'

const DefaultNavToolbar = () => {
  const dispatch = useAppDispatch()
  const { showSidebar, suspend, accountDeletion } = useAppSelector((state) => state.ui)

  const toggleMenu = () => dispatch(toggleSidebar(!showSidebar))

  return (
    <>
      {suspend || accountDeletion ? null : <NotificationBell />}
      <HelpCenter />
      <button onClick={toggleMenu} data-testid='hamburger-menu' className='w-full'>
        <MdMenu className='h-7 !w-7 cursor-pointer text-pop-grey-900' />
      </button>
    </>
  )
}

export default DefaultNavToolbar
